import React, { Component } from 'react'
import { RightOutlined } from '@ant-design/icons'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import { Button, Col, Row, Switch, MagicInput } from 'hljd'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'
// 连麦成功用户list
import LinkSuccessUsersModal from './linkSuccessUsersModal'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = props.store.liveLinkMicrophoneStore
  }

  // UNSAFE_componentWillMount() {
  //   // 这里无需初始化，已在上级store初始化，为了能第一时间看到待接入用户
  //   this.store.initData()
  // }

  render() {
    const {
      isLinkMicrophone,
      changeLinkMicrophone,
      linkMicrophoneGift,
      changeLinkMicrophoneGift,
      isLinkMicrophoneUser = {},
      isLinkMicrophoneUsers,
      showMore = false,
      open,
      changeOpen,
      startLinkMicrophone,
      stopLinkMicrophone,
      showLinkSuccessUsersModal
    } = this.store
    return (
      <div className={Style['live-linkMicrophone-wrap']}>
        <Row>
          <Col span={2} style={{ textAlign: 'right' }}>
            连麦设置
          </Col>
          <Col span={2} offset={1}>
            <Switch
              className={Style['set-link']}
              checkedChildren="开"
              unCheckedChildren="关"
              checked={isLinkMicrophone}
              onChange={changeLinkMicrophone}
            />
          </Col>
          <Col
            span={13}
            style={{
              display: 'inline-block',
              height: '22px',
              lineHeight: '22px'
            }}
          >
            <a
              rel="noopener noreferrer"
              href="https://www.yuque.com/zhiboxiaozhushou/tihy4t/sgf0al"
              target="_blank"
              style={{ color: '#FF801A' }}
            >
              连麦怎么玩，点击这里查看攻略～
            </a>
          </Col>
          <Col span={6} style={{ textAlign: 'right' }}>
            <a
              href="javascript:void(0);"
              style={{ color: '#448AFC' }}
              onClick={showLinkSuccessUsersModal}
            >
              连麦成功名单<RightOutlined />
            </a>
          </Col>
        </Row>
        {isLinkMicrophone
          ? [
              <Row>
                <Col span={2} style={{ textAlign: 'right' }}>
                  连麦礼
                </Col>
                <Col offset={1} span={21}>
                  <div className={Style['link-gift']}>
                    <MagicInput.TextArea
                      maxLength={15}
                      showCount
                      value={linkMicrophoneGift}
                      onChange={changeLinkMicrophoneGift}
                      rows="3"
                      autoSize={{ minRows: 3, maxRows: 3 }}
                      placeholder="设置连麦礼可鼓励用户参与直播连麦互动～"
                    />
                    <p className={Style.bottom}>
                      <Button type="primary" onClick={changeLinkMicrophone}>
                        提交
                      </Button>
                    </p>
                  </div>
                </Col>
              </Row>,
              <Row>
                <Col span={2} style={{ textAlign: 'right' }}>
                  连麦队列
                </Col>
                <Col offset={1} span={21}>
                  <span>{isLinkMicrophoneUser.nick}</span>
                  {isLinkMicrophoneUser.status && (
                    <Button
                      size="small"
                      style={{
                        height: 20,
                        marginLeft: 14,
                        border: 0,
                        outline: 'none',
                        boxShadow: 'none'
                      }}
                      href="javascript:void(0)"
                      onClick={() =>
                        stopLinkMicrophone(
                          isLinkMicrophoneUser,
                          this.props.store.ws
                        )
                      }
                    >
                      结束连麦
                    </Button>
                  )}
                </Col>
              </Row>,
              isLinkMicrophoneUsers.length ? (
                <Row style={{ marginTop: '20px' }}>
                  <Col span={2} />
                  <Col offset={1} span={21}>
                    <div className={Style['link-microphone-users-wrap']}>
                      <h4 className={Style.head}>待接入：</h4>
                      <div className={Style['link-microphone-users']}>
                        {(!open
                          ? isLinkMicrophoneUsers.slice(0, 6)
                          : isLinkMicrophoneUsers
                        ).map(
                          (item, index) =>
                            item.status == 1 ? (
                              <div key={index} className={Style['users-item']}>
                                <span className={Style['users-item-nick']}>
                                  {item.nick}
                                </span>
                                <Button
                                  size="small"
                                  className={Style['users-item-a']}
                                  style={{
                                    height: 20,
                                    border: 0,
                                    outline: 'none',
                                    boxShadow: 'none'
                                  }}
                                  href="javascript:void(0)"
                                  onClick={() =>
                                    startLinkMicrophone(
                                      item,
                                      this.props.store.ws
                                    )
                                  }
                                >
                                  接入
                                </Button>
                              </div>
                            ) : null
                        )}
                        {showMore && (
                          <p className={Style.more}>
                            <span onClick={changeOpen}>
                              {open ? '收起更多' : '展开更多'}
                              <LegacyIcon type={open ? 'up' : 'down'} />
                            </span>
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null
            ]
          : null}
        <LinkSuccessUsersModal />
      </div>
    )
  }
}
